module.exports = __webpack_public_path__ + "img/reds.2845a97.png";